import { useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_URL =
  'https://wa.me/34625833080?text=Hola%20Wingfold!%20Me%20interesa%20el%20servicio%20de%20Social%20Media%20y%20me%20gustar%C3%ADa%20recibir%20una%20propuesta.';

const bloques = [
  {
    title: 'Estrategia de contenido',
    intro: 'Creamos un plan de contenido personalizado según tu marca, objetivos y público ideal.',
    items: [
      'Análisis de tu negocio y competencia.',
      'Definición de pilares de contenido.',
      'Calendario mensual de publicaciones.',
      'Planificación de campañas y fechas clave.',
    ],
  },
  {
    title: 'Redacción de copies',
    intro: 'Escribimos textos pensados para captar la atención y generar interacción.',
    items: [
      'Copies para Instagram, Facebook, TikTok y LinkedIn.',
      'Llamados a la acción efectivos.',
      'Adaptación del tono de comunicación de tu marca.',
      'Optimización para mayor alcance y engagement.',
    ],
  },
  {
    title: 'Diseño gráfico',
    intro: 'Desarrollamos piezas visuales profesionales que fortalecen la identidad de tu marca.',
    items: [
      'Diseños para publicaciones del feed.',
      'Carruseles informativos.',
      'Stories.',
      'Banners promocionales.',
      'Adaptación al manual de identidad visual.',
    ],
  },
  {
    title: 'Gestión de publicaciones',
    intro: 'Nos encargamos de que tu contenido llegue a tiempo y con la mejor presentación.',
    items: [
      'Programación de publicaciones.',
      'Organización del calendario.',
      'Revisión antes de publicar.',
      'Optimización de horarios de publicación.',
    ],
  },
  {
    title: 'Reportes mensuales',
    intro: 'Medimos el desempeño para que sepas qué está funcionando y cómo seguir creciendo.',
    items: [
      'Alcance e impresiones.',
      'Interacciones.',
      'Crecimiento de la comunidad.',
      'Rendimiento de las publicaciones.',
      'Recomendaciones para el siguiente mes.',
    ],
  },
];

const proceso = [
  'Reunión inicial para conocer tu marca.',
  'Desarrollo de la estrategia.',
  'Diseño y redacción del contenido.',
  'Revisión y aprobación.',
  'Programación y publicación.',
  'Análisis de resultados y mejora continua.',
];

export const SocialMedia = () => {
  useEffect(() => {
    document.title = 'Social Media | Wingfold';
    return () => {
      document.title = 'Wingfold | Performance Marketing';
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-4xl mx-auto px-6 py-24">
        <a href="/#servicios" className="font-mono text-[11px] tracking-widest uppercase text-gold hover:text-white transition-colors mb-12 inline-block">
          ← Volver
        </a>

        <div className="font-mono text-gold text-xs tracking-[0.3em] uppercase mb-6 flex items-center gap-3">
          <span className="w-12 h-px bg-gold" />
          Social Media
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight leading-[1.1] mb-6">
          Haz crecer tu marca con una estrategia que{' '}
          <span className="italic font-medium" style={{ color: '#C56875' }}>genera resultados</span>
          <span className="text-gold">.</span>
        </h1>
        <p className="font-sans text-lg text-white/60 leading-relaxed max-w-3xl mb-20">
          En nuestra agencia de publicidad no solo publicamos contenido: diseñamos una estrategia integral para que tu marca tenga una presencia profesional, conecte con su audiencia y alcance sus objetivos comerciales.
        </p>

        <h2 className="font-display text-3xl font-light mb-10">¿Qué incluye nuestro servicio?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-24">
          {bloques.map((b) => (
            <section key={b.title} className="dark-card rounded-2xl p-8">
              <h3 className="font-display text-xl font-medium text-white mb-3">{b.title}</h3>
              <p className="font-sans text-sm text-white/60 leading-relaxed mb-5">{b.intro}</p>
              <ul className="space-y-2 font-sans text-sm text-white/70">
                {b.items.map((item) => (
                  <li key={item} className="flex gap-3">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-gold shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <h2 className="font-display text-3xl font-light mb-10">Nuestro proceso</h2>
        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-24">
          {proceso.map((paso, i) => (
            <li key={paso} className="dark-card rounded-2xl p-6">
              <span className="font-mono text-gold text-xs tracking-widest">{String(i + 1).padStart(2, '0')}</span>
              <p className="font-sans text-sm text-white/80 leading-relaxed mt-3">{paso}</p>
            </li>
          ))}
        </ol>

        <section className="dark-card rounded-2xl p-8 sm:p-12 text-center">
          <h2 className="font-display text-3xl sm:text-4xl font-light mb-4">
            ¿Listo para impulsar tu presencia en redes sociales?
          </h2>
          <p className="font-sans text-white/60 leading-relaxed mb-2">
            Convirtamos tus redes en una herramienta de crecimiento para tu negocio.
          </p>
          <p className="font-sans text-white/60 leading-relaxed mb-10">
            Escríbenos y recibe una propuesta personalizada.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/#contacto"
              className="px-6 py-3 bg-gold text-black text-sm font-semibold rounded-full hover:bg-gold-400 transition-all duration-300 gold-glow"
            >
              Solicitar propuesta
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] hover:bg-[#20BA5A] text-white text-sm font-semibold transition-colors duration-300"
            >
              <FaWhatsapp className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};
